import React from "react";
import { useSelector } from "react-redux";
import { getTranslation } from "../translations/getTranslations";
import { NoData } from "../components/NoData";
import Gateway from "../components/Gateway";

const ManageGateways = ({ isMobile }) => {
  const language = useSelector(state => state.settings.language);
  const gateways = useSelector(state => state.gateways.data);
  const translation = key => getTranslation("manageGateways", key, language);

  return (
    <div className="flex h-full flex-col overflow-hidden bg-backgroundPrimary p-10">
      <div className="flex-grow overflow-y-auto">
        {gateways.length === 0 ? (
          <NoData title={translation("_noGatewaysFound")} message={translation("_noGatewaysFoundDesc")} />
        ) : (
          <div className="flex flex-wrap justify-evenly gap-4 overflow-hidden p-4">
            {gateways.map((gateway, index) => (
              <Gateway isMobile={isMobile} key={index} gateway={gateway} index={index} type={"manageGateways"} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageGateways;
